// extracted by mini-css-extract-plugin
module.exports = {"headerActions":"APIPurchasePage_headerActions__3_04g","inputContainer":"APIPurchasePage_inputContainer__TCNSG"};